import React from 'react';
import { Box, Typography, Link, Container, Grid, IconButton } from '@mui/material';
import { useLoaderData } from 'react-router-dom';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
  const { socials, contact } = useLoaderData();
  const socialLinks = [
    { name: 'Github', icon: fab.faSquareGithub, url: socials.github },
    { name: 'LinkedIn', icon: fab.faLinkedin, url: socials.linkedin },
    { name: 'Facebook', icon: fab.faSquareFacebook, url: socials.facebook }
  ];
  return (
    <Box component="footer" sx={{ py: 4, backgroundColor: 'background.paper', mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Email: <Link href={`mailto:${contact.primaryEmail}`}>{contact.primaryEmail}</Link>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Typography variant="h6" gutterBottom>
              Follow Me
            </Typography>
            <Box>
            {socialLinks.map((social, index) => (
              <IconButton key={index} href={social.url} target="_blank" color="inherit">
                <FontAwesomeIcon icon={social.icon} />
              </IconButton>
            ))}
            </Box>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} Naga Venkata Satish Divvi. All rights reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer; 